import { render, staticRenderFns } from "./LiveDiStatistics.vue?vue&type=template&id=6687388e&"
import script from "./LiveDiStatistics.vue?vue&type=script&lang=js&"
export * from "./LiveDiStatistics.vue?vue&type=script&lang=js&"
import style0 from "./LiveDiStatistics.vue?vue&type=style&index=0&id=6687388e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6687388e')) {
      api.createRecord('6687388e', component.options)
    } else {
      api.reload('6687388e', component.options)
    }
    module.hot.accept("./LiveDiStatistics.vue?vue&type=template&id=6687388e&", function () {
      api.rerender('6687388e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/livedi/LiveDiStatistics.vue"
export default component.exports